export const clinic = {
  // Brand
  name: "Olive Dental Clinic",
  legalName: "Olive Dental Clinic",
  shortName: "Olive Dental",
  tagline: "Healthy Smiles. Trusted Dental Care.",
  slogan: "Where Beautiful Smiles Begin",

  // Website
  website: "https://olivedentals.in",
  domain: "olivedentals.in",

  // Contact
  email: "olivesdentalclinic@gmail.com",

  // Statistics
  established: "2012",
  experience: "13+ Years",
  happyPatients: "5000+",
  branches: 3,

  // Main Doctor
  chiefDoctor: "Dr. Thousif Ahammed",

  // Business
  businessType: "Dental Clinic",
  category: "Dentist",

  // Default Branch
  defaultBranch: "mangalam",

  // Brand Colors
  colors: {
    primary: "#4A7C59",
    secondary: "#2D5A3F",
    accent: "#D4AF37",
    background: "#FFFFFF"
  },

  // Images
  assets: {
    logo: "/images/olive11.png",
    favicon: "/favicon.ico",
    ogImage: "/og-image.jpg",
    logoAlt: "Olive Dental Clinic Logo"
  },

  // Social
  social: {
    facebook: "",
    instagram: "",
    youtube: "",
    linkedin: "",
    whatsapp: "",
    googleBusiness: ""
  },

  // SEO
  seo: {
    title:
      "Olive Dental Clinic | Best Dental Clinic in Mangalam, Koottayi & Vettom",

    description:
      "Olive Dental Clinic provides advanced dental treatments including Dental Implants, Root Canal Treatment, Teeth Cleaning, Aligners, Cosmetic Dentistry and Family Dental Care across Mangalam, Koottayi and Vettom.",

    keywords: [
      "Olive Dental Clinic",
      "Best Dental Clinic Mangalam",
      "Best Dental Clinic Koottayi",
      "Best Dental Clinic Vettom",
      "Best Dentist Malappuram",
      "Best Dental Clinic Tirur",
      "Dental Clinic Near Me",
      "Dentist Near Me",
      "Dental Implants",
      "Root Canal Treatment",
      "Teeth Cleaning",
      "Aligners",
      "Kids Dentist",
      "Cosmetic Dentistry",
      "General Dentistry",
      "Family Dental Care"
    ],

    author: "Olive Dental Clinic",

    robots: "index,follow",

    canonical: "https://olivedentals.in"
  }
};